import React from 'react';
import "./DotCircleLoader.css";
import { useSelector } from 'react-redux';
import { DotCircleSpinner } from './DotCircleSpinner';

export const DotCircleLoader = () => {
    const { isShowed } = useSelector(store => store.loader);
    if (!isShowed) return;
  return (
    <div className='loader-container'>
        <DotCircleSpinner />
    </div>
  )
}
